export default "__VITE_PUBLIC_ASSET__19450afb__"